import dynamic from 'next/dynamic';

export type UnRegisterModalProps = {
  isOpenModal: boolean;
  contentModal: {
    title: string;
    description: string;
    labelUnRegistration: string;
    reasonUnregistration: Array<{
      label: string;
      value: string;
    }>;
    buttonContinueRegistration: string;
    buttonUnRegistration: string;
  };
};

export const UnRegisterModal = dynamic<UnRegisterModalProps>(
  () => import('components/modals/unRegisterModal/UnRegisterModal').then((mod) => mod.UnRegisterModal),
  { ssr: false }
);
